<template>
  <el-popover
    :title="title"
    :content="message"
    :placement="placement"
    trigger="hover"
    :width="width"
  >
    <template>
      <span slot="reference">{{ label }}</span>
    </template>
    <div v-html="message"></div>
  </el-popover>
</template>

<script>
export default {
  props: {
    label: { type: String },
    message: { type: String },
    placement: { type: String, default: 'top' },
    width: { type: Number, default: 300 },
    title: { type: String, default: 'Tip' },
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/colors.scss';
</style>
